__turbopack_context__.v({
  "accordionSlideOverwrite": "auth-module-scss-module__zQGVUa__accordionSlideOverwrite",
  "content": "auth-module-scss-module__zQGVUa__content",
  "fadeIn": "auth-module-scss-module__zQGVUa__fadeIn",
  "fadeOut": "auth-module-scss-module__zQGVUa__fadeOut",
  "form": "auth-module-scss-module__zQGVUa__form",
  "infoCard": "auth-module-scss-module__zQGVUa__infoCard",
  "link": "auth-module-scss-module__zQGVUa__link",
  "otherAction": "auth-module-scss-module__zQGVUa__otherAction",
  "resendButton": "auth-module-scss-module__zQGVUa__resendButton",
  "scaleIn": "auth-module-scss-module__zQGVUa__scaleIn",
  "scaleOut": "auth-module-scss-module__zQGVUa__scaleOut",
  "submitButton": "auth-module-scss-module__zQGVUa__submitButton",
  "textField": "auth-module-scss-module__zQGVUa__textField",
  "zoomIn": "auth-module-scss-module__zQGVUa__zoomIn",
  "zoomOut": "auth-module-scss-module__zQGVUa__zoomOut",
});
